import { CartData } from '@/features/cart/shared/types/cart.types';

export const fetchCart = async (): Promise<CartData | null> => {
  const response = await fetch('/api/cart', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};
